const routesListModule = {
	namespaced: true,
	state: {
		routesList: [],
	},
	mutations: {
		// 设置路由，菜单中使用到
		getRoutesList(state, data) {
			// function buildRoutes(data) {
			// 	return data.map(item => {
			// 		let newStr = item.url.replace(/^\//, '');
			// 		let routeInfo = {
			// 			path: item.url,
			// 			name: newStr,
			// 			component: item.url,
			// 			meta: {
			// 				title: `message.router.${newStr}`,
			// 				isLink: "",
			// 				isHide: false,
			// 				isKeepAlive: true,
			// 				isAffix: true,
			// 				isIframe: false,
			// 				roles: ["admin"],
			// 				icon: item.icon
			// 			}
			// 		};

			// 		if (Array.isArray(item.children) && item.children.length > 0) {
			// 			routeInfo.children = buildRoutes(item.children);
			// 		}

			// 		return routeInfo;
			// 	});
			// }

			// state.routesList = buildRoutes(data);
			state.routesList=data
		},
	
	},
	actions: {
		// 设置路由，菜单中使用到
		async setRoutesList({ commit }, data) {

			commit('getRoutesList', data);
		},
	},
};

export default routesListModule;
